// @flow
import * as React from 'react';

import type {IndonesiaBankCodesContext} from 'docs/types';
import {defineMessages, FormattedMessage} from 'react-intl';
import {Table, TableHeaderCell, TableCell} from '../../core/Table/Table';

type Props = {|
  entries: $PropertyType<IndonesiaBankCodesContext, 'codes'>,
|};

const messages = defineMessages({
  bankName: {
    id: 'docsApp.components.IndonesianBankCodesTable.headerCells.bankName',
    description: 'Bank Name',
    defaultMessage: 'Bank Name',
  },
  bankCode: {
    id: 'docsApp.components.IndonesianBankCodesTable.headerCells.bankCode',
    description: 'Bank Code',
    defaultMessage: 'Bank Code',
  },
});

export const IndonesianBankCodesTable = ({entries}: Props) => {
  return (
    <Table type="striped">
      <thead>
        <tr>
          <TableHeaderCell>
            <FormattedMessage {...messages.bankName} />
          </TableHeaderCell>
          <TableHeaderCell>
            <FormattedMessage {...messages.bankCode} />
          </TableHeaderCell>
        </tr>
      </thead>
      <tbody>
        {entries.map((entry) => (
          <tr key={entry.bank_code}>
            <TableCell>
              <strong>{entry.bank_name}</strong>
            </TableCell>
            <TableCell>{entry.bank_code}</TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
